export const ironsClub = [
  "3i",
  "4i",
  "5i",
  "6i",
  "7i",
  "8i",
  "9i",
  "PW",
  "GW",
  "SW",
  "LW",
];

export const driversClub = [
  "D",
  "3w",
  "5w",
  "7w",
  "9w",
  "2h",
  "3h",
  "4h",
  "5h",
  "6h",
];
